import * as React from 'react';
import classnames from 'classnames';
import { FieldProps } from './props';
import './autocomplete.scss';
import { convertPascalCaseToWords } from '../../../../core';

const EntityDropdown: React.FunctionComponent<FieldProps> = (props) => {
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<string | undefined>(
    props.defaultValue || undefined
  );

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const clickDropDown = () => {
    if (props.disabled) {
      return;
    }

    setShowDropDown(!showDropDown);
  };

  const handleSelect = (item: string) => {
    setSelectedItem(item);
    setShowDropDown(false);

    if (props.onChange != null) {
      props.onChange(item);
    }
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDropDown(false);
    }
  };

  const renderIcon = () => {
    if (selectedItem === 'OwnerOnly') {
      return (
        <i className="icon-visibility-group-1 text-primary mr-2 pr-1 font-base">
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
          <span className="path4"></span>
          <span className="path5"></span>
          <span className="path6"></span>
          <span className="path7"></span>
          <span className="path8"></span>
        </i>
      );
    }
    if (selectedItem === 'OwnersVisibilityGroup') {
      return (
        <i className="icon-visibility-group-2 text-primary mr-2 pr-1 font-base">
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
          <span className="path4"></span>
          <span className="path5"></span>
          <span className="path6"></span>
          <span className="path7"></span>
          <span className="path8"></span>
        </i>
      );
    }
    if (selectedItem === 'OwnersVisibilityGroupAndSubGroup') {
      return (
        <i className="icon-visibility-group-3 text-primary mr-2 pr-1 font-base">
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
          <span className="path4"></span>
          <span className="path5"></span>
          <span className="path6"></span>
          <span className="path7"></span>
          <span className="path8"></span>
        </i>
      );
    }
    if (selectedItem === 'EntireCompany') {
      return (
        <i className="icon-visibility-group-4 text-primary mr-2 pr-1 font-base"></i>
      );
    }
    return <></>;
  };

  return (
    <React.Fragment>
      {props.label && <label className={props.labelClass}>{props.label}</label>}
      <div className="custom-dropdown position-relative" ref={wrapperRef}>
        <div
          onClick={clickDropDown}
          className="custom-dropdown__value  border rounded-sm font-normal d-flex align-items-center font-weight-semibold cursor-pointer"
        >
          <div className="flex-fill text-truncate custom-dropdown__value-text py-2 d-flex align-items-center">
            {props.loadingText ? (
              props.loadingText
            ) : (
              <>
                {selectedItem && props.defaultValue ? (
                  <>
                    {renderIcon()}
                    {convertPascalCaseToWords(selectedItem)}
                  </>
                ) : (
                  `${props.placeholder}`
                )}
              </>
            )}
          </div>
          {(!selectedItem || !props.defaultValue || !props.onReset) && (
            <i className="icon-chevron-down ml-auto"></i>
          )}
          {selectedItem && props.defaultValue && props.onReset && (
            <i
              onClick={() => {
                setSelectedItem(undefined);
                props.onReset?.();
              }}
              className="icon-close ml-auto"
            ></i>
          )}
        </div>
        {showDropDown && !props.disabled && (
          <>
            <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-9 pt-0 font-normal">
              <div
                onClick={() => handleSelect('OwnerOnly')}
                className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
              >
                <div className="col gutter-10 pr-0 row sales-person align-items-center">
                  <div className="col-12 pl-0 d-flex">
                    <div>
                      <i className="icon-visibility-group-1 text-primary mr-2 pr-1 font-base">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                        <span className="path7"></span>
                        <span className="path8"></span>
                      </i>
                    </div>
                    <div className="font-weight-normal">
                      <div className="font-weight-semibold mb-1">
                        Owner Only
                      </div>
                      Only the owner and users in the parent groups can see and
                      edit the details.
                    </div>
                  </div>
                </div>
              </div>

              <div
                onClick={() => handleSelect('OwnersVisibilityGroup')}
                className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
              >
                <div className="col gutter-10 pr-0 row sales-person align-items-center">
                  <div className="col-12 pl-0 d-flex">
                    <div>
                      <i className="icon-visibility-group-2 text-primary mr-2 pr-1 font-base">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                        <span className="path7"></span>
                        <span className="path8"></span>
                      </i>
                    </div>
                    <div className="font-weight-normal">
                      <div className="font-weight-semibold mb-1">
                        Owner's Visibility Group
                      </div>
                      Users in the same visibility group and users in the parent
                      groups can see and edit the details
                    </div>
                  </div>
                </div>
              </div>

              <div
                onClick={() => handleSelect('OwnersVisibilityGroupAndSubGroup')}
                className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
              >
                <div className="col gutter-10 pr-0 row sales-person align-items-center">
                  <div className="col-12 pl-0 d-flex">
                    <div>
                      <i className="icon-visibility-group-3 text-primary mr-2 pr-1 font-base">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                        <span className="path7"></span>
                        <span className="path8"></span>
                      </i>
                    </div>
                    <div className="font-weight-normal">
                      <div className="font-weight-semibold mb-1">
                        Owner's Visibility Group And Sub Group
                      </div>
                      Users in the same visibility group, sub groups and users
                      in the parent groups can see and edit the details
                    </div>
                  </div>
                </div>
              </div>

              <div
                onClick={() => handleSelect('EntireCompany')}
                className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
              >
                <div className="col gutter-10 pr-0 row sales-person align-items-center">
                  <div className="col-12 pl-0 d-flex">
                    <div>
                      <i className="icon-visibility-group-4 text-primary mr-2 pr-1 font-base"></i>
                    </div>
                    <div className="font-weight-normal">
                      <div className="font-weight-semibold mb-1">
                        Entire Company
                      </div>
                      All users in the company can see and edit details
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default EntityDropdown;
